export default function computeCampaignKpiMetrics(campaigns = []) {
  const overallBudget = campaigns.reduce((total, camp) => {
    return total + (camp.influencer_budget + camp.media_budget + camp.social_budget)
  }, 0)

  const finishedCount = campaigns.filter(camp => camp.is_finished).length
  const ongoingCount = campaigns.filter(camp => !camp.is_finished).length
  const influencersWorkedWith = campaigns
    .map(camp => camp.influencer_count)
    .reduce((a, b) => a + b, 0)

  return { overallBudget, finishedCount, ongoingCount, influencersWorkedWith }
}
